import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Create the context
const SessionContext = createContext();

// Create a provider component
export const SessionProvider = ({ children }) => {
    const [sessionTime, setSessionTime] = useState(null);

    const setSessionTimeData = (time) => {
        setSessionTime(time);
    };

    // Function to update session time
    const updateSessionTime = () => {
        setSessionTimeData(new Date().toISOString());
    };

    // Add global event listeners
    useEffect(() => {
        const events = ['click', 'keypress', 'scroll'];
        events.forEach(event => {
            window.addEventListener(event, updateSessionTime);
        });

        // Cleanup event listeners on unmount
        return () => {
            events.forEach(event => {
                window.removeEventListener(event, updateSessionTime);
            });
        };
    }, []);

    return (
        <SessionContext.Provider value={{ sessionTime, setSessionTimeData }}>
            {children}
        </SessionContext.Provider>
    );
};

// Add prop types validation
SessionProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

// Custom hook to use the session context
export const useSession = () => {
    return useContext(SessionContext);
};